import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TopNavBar, BottomNavBar } from "./components/index";
import { HomePage, Login, EvaluateAchievableColor } from "./routes/index";
import { Navigate } from "react-router-dom";
import { Layout } from "./components/layout";
import { useEffect } from "react";
import { onIdTokenChanged } from "firebase/auth";
import auth from "./utils/authentication/firebase";
import { useStoreActions } from "easy-peasy";
import ProtectedRoute from './ProtectedRoute';
import { TOKEN_REFRESH_INTERVAL } from "./utils/constant";
function App() {
  const setCurrentUser = useStoreActions((actions) => actions.setCurrentUser);
  useEffect(() => {
    return onIdTokenChanged(auth,async (user) => {
      if (!user) {
        localStorage.setItem("avEcoAccessToken", "");
        setCurrentUser({ displayName: "", email: "" });
      } else {
        setCurrentUser({
          displayName: user.displayName || "",
          email: user.email,
        });
        localStorage.setItem("avEcoAccessToken", user.accessToken);
      }
    });
  }, []);

  useEffect(() => {
    const handle = setInterval(async () => {
      const user = auth.currentUser;
      if (user) {
        let token = await user.getIdToken(true);
        localStorage.setItem("avEcoAccessToken", token);
      }
    }, TOKEN_REFRESH_INTERVAL);
    return () => clearInterval(handle);
  }, []);
  
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
              <Layout>
                <HomePage />
              </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/evaluate-achievable-color"
            element={
              <ProtectedRoute>
                <Layout>
                  <EvaluateAchievableColor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
